<div><ng-content></ng-content></div><i class="fa" *ngIf="target.matches.length > 1" [ngClass]="{'fa-caret-up' : active && sort == 'descending', 'fa-caret-down': active && sort == 'ascending', 'fa-sort opacity-30': !active}"></i>
